import type { Account } from '../accounts/accountsTypes';
import { isAccountConnected } from '../accounts/accountsUtils';
import { ShowBalance } from './balanceTypes';

export type AccountBalanceInput = Pick<
  Account,
  'type' | 'isClosed' | 'isConnected' | 'institutionLoginId' | 'currentBalanceAsOf' | 'onlineBalance'
>;

export const getBalanceForAccount = (account: AccountBalanceInput | undefined, balanceType: string): number => {
  if (!account || account.isClosed) {
    return 0;
  }

  if (!isAccountConnected(account)) {
    return account.currentBalanceAsOf || 0;
  }

  // For investment and loan accounts, always use online balance
  if (account.type === 'INVESTMENT' || account.type === 'LOAN') {
    return account.onlineBalance || 0;
  }

  if (balanceType === ShowBalance.BANK_REPORTED) {
    return typeof account.onlineBalance === 'number'
      ? account.onlineBalance
      : typeof account.currentBalanceAsOf === 'number'
        ? account.currentBalanceAsOf
        : 0;
  }

  if (typeof account.currentBalanceAsOf === 'number') {
    return account.currentBalanceAsOf;
  }
  if (typeof account.onlineBalance === 'number') {
    return account.onlineBalance;
  }
  return 0;
};
